export const deliveryMethodsSnakeNames = {
  0: "email_sent_at",
  1: "protocol_generated_at",
  2: "panel_sent_at",
  3: "whatsapp_sent_at",
};